<div class="flex flex-col items-center justify-center text-center">
  <img
    src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/not-found-car.webp"
    alt="not-found"
    class="h-[98px] w-[189px]" />

  <p class="font-barlow text-blue-ocean mt-4 text-xl leading-7 font-extrabold italic">{{ title() }}</p>

  <p class="font-barlow mt-2 max-w-[300px] text-base leading-6 font-semibold text-gray-400">
    {{ description() }}
  </p>
</div>
